import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILED,
    GET_USER_BY_ID_REQUEST,
    GET_USER_BY_ID_SUCCESS,
    GET_USER_BY_ID_FAILED,
    GET_USER_WITH_ROLES_REQUEST,
    GET_USER_WITH_ROLES_SUCCESS,
    GET_USER_WITH_ROLES_FAILED,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILED,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILED,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILED,
    ASSIGN_ROLE_REQUEST,
    ASSIGN_ROLE_SUCCESS,
    ASSIGN_ROLE_FAILED,
    GET_USER_ROLE_ASSIGNMENTS_REQUEST,
    GET_USER_ROLE_ASSIGNMENTS_SUCCESS,
    GET_USER_ROLE_ASSIGNMENTS_FAILED,
    REMOVE_ROLE_ASSIGNMENT_REQUEST,
    REMOVE_ROLE_ASSIGNMENT_SUCCESS,
    REMOVE_ROLE_ASSIGNMENT_FAILED,
    CLEAR_CURRENT_USER,
    CLEAR_ERRORS
} from '../actions/UsersActions';

const initialState = {
    listdata: [],
    pagination: {
        totalRecords: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
        hasNext: false,
        hasPrevious: false
    },
    user: null,
    userWithRoles: null,
    roleAssignments: [],
    loading: false,
    error: null,
    validationErrors: null,
    success: false
};

const UsersReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Users Cases
        case GET_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination,
                error: null,
                success: true
            };

        case GET_USERS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Get User by ID Cases
        case GET_USER_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USER_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                error: null,
                success: true
            };

        case GET_USER_BY_ID_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Get User with Roles Cases
        case GET_USER_WITH_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USER_WITH_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                userWithRoles: action.payload,
                error: null,
                success: true
            };

        case GET_USER_WITH_ROLES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Create User Cases
        case CREATE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: [action.payload, ...state.listdata],
                error: null,
                success: true
            };

        case CREATE_USER_FAILED:
            return {
                ...state,
                loading: false,
                error: typeof action.payload === 'object' ? action.payload.message : action.payload,
                validationErrors: typeof action.payload === 'object' ? action.payload.validationErrors : null,
                success: false
            };

        // Update User Cases
        case UPDATE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                listdata: state.listdata.map(user =>
                    user.id === action.payload.id ? action.payload : user
                ),
                error: null,
                success: true
            };

        case UPDATE_USER_FAILED:
            return {
                ...state,
                loading: false,
                error: typeof action.payload === 'object' ? action.payload.message : action.payload,
                validationErrors: typeof action.payload === 'object' ? action.payload.validationErrors : null,
                success: false
            };

        // Delete User Cases
        case DELETE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case DELETE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: state.listdata.filter(user => user.id !== action.payload),
                error: null,
                success: true
            };

        case DELETE_USER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Assign Role Cases
        case ASSIGN_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case ASSIGN_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                roleAssignments: [action.payload, ...state.roleAssignments],
                error: null,
                success: true
            };

        case ASSIGN_ROLE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Get User Role Assignments Cases
        case GET_USER_ROLE_ASSIGNMENTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USER_ROLE_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                roleAssignments: action.payload,
                error: null,
                success: true
            };

        case GET_USER_ROLE_ASSIGNMENTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Remove Role Assignment Cases
        case REMOVE_ROLE_ASSIGNMENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case REMOVE_ROLE_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                roleAssignments: state.roleAssignments.filter(
                    assignment => assignment.id !== action.payload
                ),
                error: null,
                success: true
            };

        case REMOVE_ROLE_ASSIGNMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // Clear Cases
        case CLEAR_CURRENT_USER:
            return {
                ...state,
                user: null,
                userWithRoles: null,
                roleAssignments: [],
                error: null,
                success: false
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                validationErrors: null,
                success: false
            };

        default:
            return state;
    }
};

export default UsersReducer;